import React, { useState, useEffect } from 'react';
import { Grid, Image, Dropdown, Icon } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import Sidemenu from './sidemenu';
import { Outlet } from 'react-router-dom';;

export default function Home() {
    const [openDropdown, setOpenDropdown] = useState(false);
    const navigate = useNavigate();
    const [username, setUsername] = useState<string | null>(null);

    const handleLogout = () => {
        Cookies.remove('auth_token');
        navigate('/login');
    };

    useEffect(() => {
        const token = Cookies.get('auth_token');
        if (token) {
            try {
                const decoded = jwtDecode<JwtPayload>(token);
                setUsername(decoded.sub ?? null);
            } catch (error) {
                Cookies.remove('auth_token');
                navigate('/login');
            }
        } else {
            navigate('/login');
        }
    }, [navigate]);

    const dropdownOptions = [
        { key: 'profile', text: 'Profile', icon: 'user', onClick: () => navigate('/profile') },
        { key: 'logout', text: 'Log Out', icon: 'sign out', onClick: handleLogout },
    ];

    return (
        <Grid>
            <Grid.Row
                className="TopRow"
                style={{
                    display: 'flex',
                    alignItems: 'center', // Centers items vertically
                    justifyContent: 'space-between', // Distributes space properly
                    height: '80px', // Matches navbar height
                    padding: '0 20px', // Adds spacing
                }}
            >
                {/* Logo Section */}
                <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                    <Image
                        className='logo'
                        src="/elius_logo_green.png"
                        style={{ height: '60px', width: 'auto', display: 'block', visibility: 'visible', padding: "10px", marginTop: "10px" }}
                        onClick={() => navigate('/')}
                    />
                </div>

                {/* Avatar and Username Section */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Icon name="user circle" size="big" /> 
                    <span style={{ fontWeight: 'bold' }}>{username}</span>
                    <Dropdown
                        trigger={<span style={{ cursor: 'pointer' }}>▼</span>}
                        pointing="top right"
                        icon={null}
                        options={dropdownOptions}
                    />
                </div>
            </Grid.Row>
            <Grid.Row className='ContentRow'>
                <Grid.Column className='SideBarColumn' width={3}>
                    <Sidemenu />
                </Grid.Column>
                <Grid.Column width={13} className='OutletColumn'>
                    <Outlet />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}
